export default "__VITE_ASSET__DA29ULOX__"